<template>

    <a-modal class="invitation"
             centered
             :width="900"
             :visible="visible"
             @cancel="$emit('cancel')"
             :maskClosable="false"
             :footer="null"
             :destroyOnClose="true"
             :confirmLoading="modalLoading">
        <a-card>
            <div class="t1">
                <div class="size4 mb-5 bold" style="color: #EA0000">{{inviteInfo.supplierName}}:</div>
                <div class="size3 t1-a">
                    <p class="">
                        <b>{{inviteInfo.tenderOrg}}</b>受<b>{{inviteInfo.purchaserUnit}}</b>委托，组织<b>{{inviteInfo.projectName}}</b>网上竞价，现邀请贵公司参与本次竞价活动。
                    </p>
                  <!--                需要提交资格审查-->
                  <div v-if="inviteInfo.isQualifications === '1'">
                    <p>如要参加项目投标，请先提交前置审查文件，前置审查通过后即可购买标书。
                    </p>
                    <p v-if="!bidZgys"><a  @click="goZgYs">
                      前置审查文件上传地址【点击可以提交前置审查文件】
                    </a></p>
                    <template v-else>
                      <template v-if="bidZgys.scjg === '0'">
                        <p style="color: #EA0000">
                          您已提交资格审查文件，正在审核中，请耐心等待。
                        </p>
                        <p style="color: #EA0000">
                          资格审查结果在24小时内通过手机短信进行通知。
                        </p>
                      </template>
                      <div v-if="bidZgys.scjg === '2'">
                        <p>您提交的资格审查文件审核不通过，请点击下面的链接查看处理：</p>
                        <p><a @click="goZgYs"> 资格审查文件上传地址【点击可以提交资格审查文件】
                        </a></p>
                      </div>
                    </template>
                  </div>
                  <div v-if="inviteInfo.isQualifications === '0' || (bidZgys && bidZgys.scjg === '1')">
                    <p>如同意参与项目竞价，请在{{inviteInfo.publicType === '1'?'竞价公告中':'登记页面'}}进行投标登记。如不同意参与，则不需做任何操作。</p>
                    <p style="color: green" v-if="bidZgys && bidZgys.scjg === '1'"> 您提交的资格审查文件已经审核通过，请点击下面的链接进行投标登记：</p>
                    <p v-if="inviteInfo.publicType === '1'">请点击<u class="color-link"  @click="announceDetails(inviteInfo.publicType)">竞价公告链接</u>，查看竞价公告和竞价文件。</p>
                    <p v-if="inviteInfo.publicType === '2'">请点击<u class="color-link"  @click="announceDetails(inviteInfo.publicType)">登记链接</u>，进行登记</p>
                  </div>
                  <p>如有疑问，请联系我司项目经办人<B>{{inviteInfo.tenderOperator}}（{{inviteInfo.tenderTel}}）</B>。感谢贵单位对本次竞价工作的支持！</p>
                </div>
                <!--                <div class="text-right">-->
                <!--                 <B>{{inviteInfo.inviteDate}}</B>-->
                <!--                </div>-->
                <!--                <div class="text-right">-->
                <!--                    <B>{{inviteInfo.tenderOrg}}</B>-->
                <!--                </div>-->
                <!--                <div class="text-right mt-3 mb-2">-->
                <!--                    <B>{{inviteInfo.inviteDate}}</B>-->
                <!--                </div>-->
            </div>
            <p class="t2">{{inviteInfo.tenderOrg}}</p>
        </a-card>
    </a-modal>

</template>

<script>
    import qs from 'qs'

    export default {
        components: {
        },
        created() {
        },
        props: {
            visible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                packs:'',
                modalLoading: false,
                subjectList: [],
                inviteInfo: {extras:{}},
                bidZgys: {},
            }
        },
        methods: {
            initData(id) {
                let that = this
                this.$http.get('/api/v1/supplier/project/getInvitedDetails.json?id='+id).then(function (res) {
                    that.inviteInfo =  res.result
                    that.bidZgys = res.result.bmsc
                });
            },
          goZgYs() {
            this.$router.push({path: '/BmscFile?projectId=' + this.inviteInfo.bidId})
          },
            announceDetails(val) {
              if('1' === val){
                if (!this.inviteInfo.announceId){
                  this.$warning({
                    title: '请耐心等待经办人发布竞价公告！！！'
                  })
                  return
                }
                let routeIndex = this.$router.resolve({
                    path: '/project/announce?id=' + this.inviteInfo.announceId
                })
                window.open(routeIndex.href, '_blank')
              }else {
                this.sign()
              }
            },
          sign() {
            this.$router.push({path: '/SignIndex?id=' + this.inviteInfo.bidId})
          },
        }
    };
</script>
<style lang="less" scoped>
    /deep/ .ant-modal-content{
        background: none;
        box-shadow: none;
    }
    /deep/ .ant-card{
        background: url("../../img/p4.png");
        background-size: 100%;
        border: none;
        height: 557px;
    }
    /deep/ .ant-modal-close-x{
        border: 2px solid #fff;
        color: #fff;
        width: 36px;
        height: 36px;
        line-height: 32px;
        border-radius: 18px;
        font-weight: bold;
    }
    /deep/ .ant-modal-close {
        top: -20px;
        right: 20px;
    }
    .t1{
        padding: 100px 40px 40px;
        color: #333;
    }
    .t1-a p{
        text-indent: 32px;
        padding: 0 10px 0 30px;
    }
    .t1-a u{
        cursor: pointer;
    }
    .t2{
        position: absolute;bottom: 20px;width: 100%;text-align: center;color: #FEE7B4;left: 0
    }
    /deep/.size3 {
      font-size: 16px !important;
      line-height: 20px !important;
    }
</style>
